'use client';

import { useEffect, type ReactNode } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { trackEvent } from '@/lib/analytics/firebaseAnalytics';
import type { AnalyticsEventName } from '@/lib/analytics/events';

interface MarketingChromeProps {
  children: ReactNode;
  analyticsEvent?: AnalyticsEventName;
}

export default function MarketingChrome({ children, analyticsEvent }: MarketingChromeProps) {
  useEffect(() => {
    if (analyticsEvent) {
      trackEvent(analyticsEvent);
    }
  }, [analyticsEvent]);

  return (
    <>
      <Header appearance="solid" />
      <main>
        {children}
        <Footer />
      </main>
    </>
  );
}
